import PropTypes from 'prop-types';
import { nullValidator } from './validators';

export const stringOrArrayPlusNull = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, nullValidator]))
]);
